import React, { useEffect, useState } from 'react';
import { termsAndConditions } from '../assets/termsContent';

const TermsOfService: React.FC = () => {
    // Initialize dark mode state from localStorage, just like ThemeToggle does
    const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
        const theme = localStorage.getItem("theme");
        if (theme) {
            return theme === "dark";
        }
        return window.matchMedia("(prefers-color-scheme: dark)").matches;
    });

    // Update when theme changes in localStorage
    useEffect(() => {
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'theme') {
                setIsDarkMode(e.newValue === 'dark');
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    // Also check for the dark class on the HTML element
    useEffect(() => {
        const observer = new MutationObserver(() => {
            const hasDarkClass = document.documentElement.classList.contains('dark');
            setIsDarkMode(hasDarkClass);
        });

        observer.observe(document.documentElement, { attributes: true });
        return () => observer.disconnect();
    }, []);

    // Function to format the terms text with proper line breaks and sections
    const formatTerms = (text: string) => {
        // Split by line breaks
        const lines = text.split('\n');

        return lines.map((line, index) => {
            // Check if the line is a section header (starts with a number followed by a dot)
            if (/^\d+\./.test(line)) {
                return (
                    <h2
                        key={index}
                        className={`text-xl font-bold mt-6 mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}
                    >
                        {line}
                    </h2>
                );
            }
            // Check if the line is the main title
            else if (line === 'Terms and Conditions') {
                return (
                    <h1
                        key={index}
                        className={`text-3xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}
                    >
                        {line}
                    </h1>
                );
            }
            // Check if the line is empty
            else if (line.trim() === '') {
                return <div key={index} className="my-2"></div>;
            }
            // Regular paragraph
            else {
                return (
                    <p
                        key={index}
                        className={`my-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}
                    >
                        {line}
                    </p>
                );
            }
        });
    };

    return (
        <div className={`min-h-screen w-full ${isDarkMode ? 'bg-gray-900' : 'bg-gray-100'}`}>
            {/* Increased top padding from pt-16 to pt-24 to provide more space below navbar */}
            <div className="max-w-4xl mx-auto mt-4 py-6 px-4 sm:px-6 lg:px-8 pt-24">
                <div className={`shadow rounded-lg p-6 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                    {formatTerms(termsAndConditions)}
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
